<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs'

export default {
  name: 'LineChart',
  extends: Line,
  components: {
    Line
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    chartData (newData) {
      this.renderChart(newData, this.options)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.renderChart(this.chartData, this.options)
    })
  }
}
</script>

<style scoped>
  canvas {
    max-height: 800px;
    height: 800px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/LineChart.vue